export enum REPORT_ACTION_TYPE {
  COST_REPORT = 'report/cost',
  ACTUAL_COST_REPORT = 'report/actualCost',
  COST_PROJECT_LIST = 'report/costProjectList',
  ACTUAL_COST_REPORT_DETAIL = 'report/actualCostReportDetail',
  ACTIVITY_REPORT = 'report/activity',
}
